export const FUNNEL_INSIGHTS_ACCESS_CAPABILITY = 'funnel_insights.access';
